module.exports = __webpack_public_path__ + "static/group-kiting-df3e6aba6178b5cd66ad196a6ed98121.jpg";